import { Box, MenuItem, Tooltip } from "@mui/material";
import Pen from "assets/img/svg/pen";
import { useTranslation } from "react-i18next";

export type ManagementModifyBalanceMenuItemProps = {
    disabled: boolean;
    /** Shown on hover when non-empty; listeners disabled when empty */
    tooltipTitle: string;
    onActivate: () => void;
};

/**
 * Menu entry for opening balance update. Uses simulated disabled state so the tooltip still works
 * while keeping valid menu list DOM (no wrapper between Menu and MenuItem).
 */
export function ManagementModifyBalanceMenuItem({
    disabled,
    tooltipTitle,
    onActivate,
}: ManagementModifyBalanceMenuItemProps) {
    const [t] = useTranslation();

    return (
        <MenuItem
            aria-disabled={disabled}
            onClick={(e) => {
                if (disabled) {
                    e.preventDefault();
                    e.stopPropagation();
                    return;
                }
                onActivate();
            }}
            sx={(theme) => ({
                width: "100%",
                ...(disabled && {
                    opacity: theme.palette.action.disabledOpacity,
                    cursor: "default",
                    "&:hover": { backgroundColor: "transparent" },
                    "&.Mui-focusVisible": { backgroundColor: "transparent" },
                }),
            })}
        >
            <Tooltip
                title={tooltipTitle}
                arrow
                disableHoverListener={!tooltipTitle}
                disableFocusListener={!tooltipTitle}
                disableTouchListener={!tooltipTitle}
            >
                <Box
                    component="span"
                    sx={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "8px",
                        width: "100%",
                    }}
                >
                    <Pen color="#2D2D2D" />
                    <span>{t("Management.ModifyBalance")}</span>
                </Box>
            </Tooltip>
        </MenuItem>
    );
}
